import { render, staticRenderFns } from "./operationConfig.vue?vue&type=template&id=4cd97e63&scoped=true"
import script from "./operationConfig.vue?vue&type=script&lang=js"
export * from "./operationConfig.vue?vue&type=script&lang=js"
import style0 from "./operationConfig.vue?vue&type=style&index=0&id=4cd97e63&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd97e63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd97e63')) {
      api.createRecord('4cd97e63', component.options)
    } else {
      api.reload('4cd97e63', component.options)
    }
    module.hot.accept("./operationConfig.vue?vue&type=template&id=4cd97e63&scoped=true", function () {
      api.rerender('4cd97e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/children/operationConfig.vue"
export default component.exports